import type { NextRequest } from "next/server";
import { FEATURE_FLAG_HEADER_PREFIX } from "@/lib/feature-flags/constants";
import type { FlagMap } from "@/lib/feature-flags/types";
import { getEnv } from "@/env";

export const SPANISH_EXPERIENCE_FLAG =
  "NEXT_PUBLIC_SPANISH_ENABLED" as const satisfies keyof FlagMap;

export const SPANISH_EXPERIENCE_DEFAULT = "legacy" as const;

export type SpanishExperienceFlagValue =
  FlagMap[typeof SPANISH_EXPERIENCE_FLAG];

export function isSpanishExperienceEnabled(
  flagValue: string | null | undefined,
): boolean {
  return flagValue === "test";
}

/**
 * Resolves the Spanish experience flag synchronously for Edge middleware.
 * Query-param overrides are applied earlier via withFeatureFlagging (request headers).
 */
export function resolveSpanishExperienceFlagFromRequest(
  req: NextRequest,
): SpanishExperienceFlagValue {
  const headerValue = req.headers.get(
    `${FEATURE_FLAG_HEADER_PREFIX}${SPANISH_EXPERIENCE_FLAG}`,
  );
  if (headerValue === "legacy" || headerValue === "test") {
    return headerValue;
  }

  const envValue = getEnv(SPANISH_EXPERIENCE_FLAG);
  if (envValue === "legacy" || envValue === "test") {
    return envValue;
  }

  return SPANISH_EXPERIENCE_DEFAULT;
}
